import { render, staticRenderFns } from "./userWatch.vue?vue&type=template&id=454c26a2&scoped=true"
import script from "./userWatch.vue?vue&type=script&lang=js"
export * from "./userWatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454c26a2",
  null
  
)

export default component.exports